import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { BlogCard } from "@/components/BlogCard";
import { Seo, breadcrumbJsonLd } from "@/components/Seo";
import { posts } from "@/content/blog/posts";
import { useFlowReveal } from "@/hooks/useFlowReveal";

const Blog = () => {
  const flowRef = useFlowReveal<HTMLUListElement>();

  return (
  <div className="min-h-screen bg-background">
    <Seo
      title="Blog"
      description="Practical guidance on WCAG, web and PDF accessibility, VPATs and remediation from the AccessBharat team."
      path="/blog"
      jsonLd={breadcrumbJsonLd([
        { name: "Home", path: "/" },
        { name: "Blog", path: "/blog" },
      ])}
    />
    <Navbar />
    <main id="main-content" tabIndex={-1}>
      <section className="section-padding pt-28 md:pt-[9rem] section-alt" aria-labelledby="blog-heading">
        <div className="mx-auto max-w-7xl">
          <p className="eyebrow mb-4">Insights</p>
          <h1
            id="blog-heading"
            className="mb-3 font-display text-3xl font-bold text-foreground md:text-4xl lg:text-5xl"
          >
            Accessibility Insights &amp; Guides
          </h1>
          <p className="mb-8 max-w-2xl text-muted-foreground">
            Practical, plain-language guidance on WCAG, web and PDF accessibility,
            VPATs and remediation.
          </p>

          {posts.length === 0 ? (
            <p className="text-muted-foreground">No posts yet — check back soon.</p>
          ) : (
            <ul ref={flowRef} className="grid list-none gap-6 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((post, i) => (
                <li key={post.slug} className="flow-step" style={{ "--i": Math.min(i, 5) } as React.CSSProperties}>
                  <BlogCard post={post} />
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </main>
    <Footer />
  </div>
  );
};

export default Blog;
